var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3187_22622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 10.6084C18.125 12.7633 17.269 14.8299 15.7452 16.3536C14.2215 17.8774 12.1549 18.7334 10 18.7334C7.84512 18.7334 5.77849 17.8774 4.25476 16.3536C2.73102 14.8299 1.875 12.7633 1.875 10.6084C1.875 8.45351 2.73102 6.38689 4.25476 4.86316C5.77849 3.33942 7.84512 2.4834 10 2.4834C12.1549 2.4834 14.2215 3.33942 15.7452 4.86316C17.269 6.38689 18.125 8.45351 18.125 10.6084ZM0 10.6084C0 13.2606 1.05357 15.8041 2.92893 17.6795C4.8043 19.5548 7.34784 20.6084 10 20.6084C12.6522 20.6084 15.1957 19.5548 17.0711 17.6795C18.9464 15.8041 20 13.2606 20 10.6084C20 7.95623 18.9464 5.41269 17.0711 3.53733C15.1957 1.66197 12.6522 0.608398 10 0.608398C7.34784 0.608398 4.8043 1.66197 2.92893 3.53733C1.05357 5.41269 0 7.95623 0 10.6084ZM9.0625 5.2959V10.6084V11.1084L9.48047 11.3857L13.2305 13.8857L14.0117 14.4053L15.0508 12.8467L14.2695 12.3271L10.9375 10.1084V5.2959V4.3584H9.0625V5.2959Z",
    fill: "#1A1818",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3187_22622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.608398)"
  })))));
};
export default SvgClock;